import { axios } from '@Root/API'

export const getAvailableFields = params => {
  return axios.get(`cognito-form-available-fields`, { params })
}
